import React, { useRef, useState } from "react";

const SignaturePad = ({ label, onSave, note, onClose, saveLabel = "Save", onSkip, skipLabel = "Skip" }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [hasDrawn, setHasDrawn] = useState(false);

    const getPos = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        return { x: clientX - rect.left, y: clientY - rect.top };
    };

    const startDrawing = (e) => {
        e.preventDefault();
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = getPos(e);
        ctx.beginPath();
        ctx.moveTo(x, y);
        setIsDrawing(true);
    };

    const draw = (e) => {
        if (!isDrawing) return;
        e.preventDefault();
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = getPos(e);
        ctx.lineTo(x, y);
        ctx.strokeStyle = "#1d1d1f";
        ctx.lineWidth = 2;
        ctx.lineCap = "round";
        ctx.stroke();
        setHasDrawn(true);
    };

    const stopDrawing = () => setIsDrawing(false);

    const clear = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setHasDrawn(false);
    };

    const save = () => {
        const dataUrl = canvasRef.current.toDataURL("image/png");
        onSave(dataUrl);
    };

        return (
            <div style={{
                position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                justifyContent: "center", zIndex: 10000
            }}>
                <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", width: "340px", position: "relative" }}>
                    {onClose && (
                        <button
                            onClick={onClose}
                            style={{
                                position: "absolute", top: "12px", right: "12px",
                                background: "none", border: "none", fontSize: "18px",
                                color: "#6e6e73", cursor: "pointer", lineHeight: 1,
                                padding: "4px"
                            }}
                            aria-label="Close"
                        >
                            ✕
                        </button>
                    )}
                    <p style={{ fontWeight: 700, fontSize: "15px", margin: "0 0 12px", color: "#1d1d1f" }}>{label}</p>
                    <canvas
                        ref={canvasRef}
                        width={300}
                        height={150}
                        style={{ border: "1px solid #ccc", borderRadius: "8px", width: "100%", touchAction: "none" }}
                        onMouseDown={startDrawing}
                        onMouseMove={draw}
                        onMouseUp={stopDrawing}
                        onMouseLeave={stopDrawing}
                        onTouchStart={startDrawing}
                        onTouchMove={draw}
                        onTouchEnd={stopDrawing}
                    />
                    {note && (
                        <p style={{ fontSize: "11px", color: "#6e6e73", margin: "10px 0 0", lineHeight: 1.4 }}>{note}</p>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "14px" }}>
                        <button onClick={clear} style={{ background: "#f5f5f7", color: "#1d1d1f", border: "none", borderRadius: "8px", padding: "8px 14px", fontSize: "13px", cursor: "pointer" }}>
                            Clear
                        </button>
                        {onSkip && (
                            <button onClick={onSkip} style={{ background: "none", color: "#6e6e73", border: "none", borderRadius: "8px", padding: "8px 14px", fontSize: "13px", cursor: "pointer" }}>
                                {skipLabel}
                            </button>
                        )}
                            <button onClick={save} disabled={!hasDrawn}
                                style={{ background: hasDrawn ? "#0071e3" : "#a0c4e8", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 14px", fontSize: "13px", fontWeight: 600, cursor: hasDrawn ? "pointer" : "default" }}>
                                {saveLabel}
                            </button>
                </div>
            </div>
        </div>
    );
};

export default SignaturePad;